import { Theme } from '@mui/material/styles'
export const getStyles = (theme: Theme) => ({
  appName: {
    fontFamily: 'Source Sans Pro Semibold',
    marginTop: theme.spacing(0.5),
  },

  appWrapper: {
    transition: 'all 0.5s ease',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    width: '150px',
    padding: `${theme.spacing(2)} ${theme.spacing(0)}`,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#F7F7F7',
    },
  },

  avatar: {
    minHeight: '45px',
    minWidth: '45px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.primary.main,
    border: '2px solid #0350A3',
    borderRadius: '50%',
    color: theme.palette.common.white,
  },
})
